import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';


import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';


import { SummaryGrantListModel, SummaryGrantModel } from '../../models/summary-grant.model'
import { GrantService } from '../../services/grant.service';

import { GrantActionTypes,LoadGrant,LoadGrantFailure,LoadGrantSuccess,LoadGrants,LoadGrantsFailure,LoadGrantsSuccess,UpdateGrant,UpdateGrantFailure,UpdateGrantSuccess,DeleteGrant,DeleteGrantFailure,DeleteGrantSuccess } from '../actions/grant.actions';

@Injectable()
export class GrantEffects {
  constructor(
    private actions$: Actions,
    private service: GrantService
  ) { }

  /** 🔹 Get All */

  
  loadGrant$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(GrantActionTypes.LoadGrants),
    switchMap((action: LoadGrants) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryGrantModel> & { summary: SummaryGrantListModel }) => {
          if (!res || !res.isSuccess) {
              return new LoadGrantsFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadGrantsSuccess({
              items: res.values,
              total: res.total,
              summary: res.summary
            });
          }),
          catchError(error => of(new LoadGrantsFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadGrantById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(GrantActionTypes.LoadGrant),
        mergeMap((action: LoadGrant) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadGrantSuccess(response)),
            catchError(error => of(new LoadGrantFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateGrant$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(GrantActionTypes.UpdateGrant),
          mergeMap((action: UpdateGrant) =>
            this.service.update(action.payload.grant).pipe(
              switchMap(updated => [
                new UpdateGrantSuccess({ grant: updated }),
              ]),
              catchError(error => of(new UpdateGrantFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteGrant$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(GrantActionTypes.DeleteGrant),
          mergeMap((action: DeleteGrant) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteGrantSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteGrantFailure({ error })))
            )
          )
        ));



}
